import _ from 'lodash';
import {apiFetch, apiSearch} from '../utility';

const apiBase = 'quickbooksFuelItem';
export const search = (p = {}) => {
	const { callback = _.noop } = p;
	return dispatch => {
		apiSearch({
			base : apiBase,
			params : {},
			dispatch,
			callback,
		});
	};
};

export const add = ({params, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: `${apiBase}.add`,
			listNameToUpdate : 'quickbooksFuelItemIds',
			params,
			successMessage :
				`Quickbooks item successfully added to the available items
				for fuel vendor billing`,
			dispatch,
			callback,
		});
	};
};